import React, { useEffect, useState, useCallback } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { viewPropertyList } from "../../Redux/Actions/rentalPropertiesActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { columnsPropertiesRental } from "../../Global Functions/columnsAntd";
import { Table } from "antd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";
// import toast from "react-hot-toast";

const ListRentalProperties = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [businessType, setBusinessType] = useState("rental");

  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { propertyRentalList, loading } = useSelector((state) => state.propertyRental || {});
  const propStatus = enumsData?.data?.PropertyStatus;

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    async (page, limit) => {
      if (!propStatus) return;

      const payload = {
        status: propStatus,
        page,
        limit,
        is_deleted: false,
        business_type: businessType || "rental",
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      await dispatch(viewPropertyList(payload));
    },
    [dispatch, debouncedSearch, propStatus, dateRange, businessType]
  );

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (propertyRentalList?.total) {
      setPagination((prev) => ({ ...prev, total: propertyRentalList.total }));
    }
  }, [propertyRentalList]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPagination((prev) => ({ ...prev, current: 1 }));
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDetails(pagination.current, pagination.pageSize, false);
    }, 1800000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <MainLayout>
      <div className="bookings_table">
        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="Rental Properties List"
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
            />
          </div>

          <div>
          </div>

          <div style={{ padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(propertyRentalList?.data) ? propertyRentalList.data : []}
              virtual
              scroll={{ x: 1700, y: 500 }}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsPropertiesRental(pagination.current, pagination.pageSize, businessType)}
            />
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </MainLayout>
  );
};

export default ListRentalProperties;